"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = exports.BmiCalculatorTitle = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _BmiCalculator = require("../../../health/components/BmiCalculator");

var _ReactStaticPage = require("../../../../../react-static/page/ReactStaticPage");

var _Breadcrumbs = require("../../../../../components/Breadcrumb/Breadcrumbs");

var _Home = require("../../Home");

var _Health = require("../Health");

var _mobxReact = require("mobx-react");

var _class;

var BmiCalculatorTitle = "BMI Calculator";
exports.BmiCalculatorTitle = BmiCalculatorTitle;

var BmiCalculatorPage = (0, _mobxReact.observer)(_class =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(BmiCalculatorPage, _Component);

  function BmiCalculatorPage() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = BmiCalculatorPage.prototype;

  _proto.render = function render() {
    return _react.default.createElement(_ReactStaticPage.ReactStaticPage, (0, _extends2.default)({
      title: BmiCalculatorTitle
    }, this.props), _react.default.createElement(_Breadcrumbs.Breadcrumbs, {
      items: [{
        label: _Health.HealthTitle,
        to: _Home.HealthTileRef
      }]
    }), _react.default.createElement("p", null, "Our Body Mass Index (BMI) calculator using the World Health Organisation (WHO) classification."), _react.default.createElement("p", null, "BMI should only be used as an indicator and in conjuction with other methods. On its own, it is potentially inaccurate to determine a persons health."), _react.default.createElement("p", null, "Using two quite easy to determine inputs, your weight and height, makes it a quick and cheap indicator of health used around the world."), _react.default.createElement(_BmiCalculator.BmiCalculator, null), _react.default.createElement("h3", {
      id: "history"
    }, "History"), _react.default.createElement("p", null, "Adolphe Quetelet was a Belgian and amongst other talents, a statistican, who created is now called BMI during his study of society in the 1830s. Originally named the \"Quetelet Index\"."), _react.default.createElement("h3", {
      id: "limitations"
    }, "Limitations"), _react.default.createElement("p", null, "It does not consider how the body is made up, e.g. muscle versus fat. Two people could weigh the same, but have vastly different body shapes. This limitation is more applicable if you are a body builder."), _react.default.createElement("p", null, "Nick Trefethen (Professor of mathematics) claims the BMI calculation will show shorter people as thinner than they are, and taller people being fatter", " ", _react.default.createElement("a", {
      href: "https://people.maths.ox.ac.uk/trefethen/bmi.html"
    }, "here"), "."), _react.default.createElement("p", null, "The basic BMI calculation does not differentiate between sex. Females tend to have a higher fat composition than males."), _react.default.createElement("p", null, "Body composition is generally different across races and by adaption to climate, which can mean BMI values could be adapted."), _react.default.createElement("p", null, "BMI for children needs to be adapted."), _react.default.createElement("p", null, "BMI may be more useful as a measurement for a larger data set like a population rather than an individual."), _react.default.createElement("p", null, "Due to different \"standards\" and changes to of them, BMI can be confusing."), _react.default.createElement("h3", {
      id: "other_techniques"
    }, "Other Techniques"), _react.default.createElement("ul", null, _react.default.createElement("li", null, "Waist circumference")));
  };

  return BmiCalculatorPage;
}(_react.Component)) || _class;

exports.default = BmiCalculatorPage;